export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://static.readdy.ai/image/7cb3e177cbbfe6dc40a85d6e7c8e7541/102467e4db67b91a927f624c83051481.jpeg"
          alt="NYC skyline at sunset"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-20 sm:py-32">
        <div className="text-center max-w-4xl mx-auto">
          <div className="inline-flex items-center gap-2 bg-white/95 backdrop-blur-sm px-4 sm:px-5 py-2 sm:py-2.5 rounded-full mb-6 sm:mb-8">
            <i className="ri-map-pin-line text-sage-500 text-base sm:text-lg"></i>
            <span className="text-xs sm:text-sm font-semibold text-gray-900">Based in NYC</span>
          </div>

          <h1 className="text-4xl sm:text-5xl lg:text-7xl xl:text-8xl font-serif font-semibold text-white mb-6 sm:mb-8 leading-tight px-4">
            <span className="italic">NYC</span> UGC Creator<br />
            &amp; Brand Storyteller
          </h1>

          <p className="hidden sm:block text-base lg:text-xl text-white/95 mb-10 sm:mb-12 max-w-3xl mx-auto leading-relaxed px-4">
            Crafting authentic content that connects brands with their audience through compelling visual narratives
          </p>

          <div className="flex flex-col sm:flex-row gap-4 sm:gap-5 justify-center items-center px-4">
            <button
              onClick={() => scrollToSection('about')}
              className="w-full sm:w-auto px-8 sm:px-10 py-3.5 sm:py-4 bg-white text-gray-900 rounded-full font-semibold hover:bg-warm-100 transition-all cursor-pointer whitespace-nowrap shadow-lg text-sm sm:text-base"
            >
              Get to Know Me
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="w-full sm:w-auto px-8 sm:px-10 py-3.5 sm:py-4 bg-gradient-to-r from-sage-500 to-caramel-400 text-white rounded-full font-semibold hover:from-sage-600 hover:to-caramel-500 transition-all cursor-pointer whitespace-nowrap shadow-lg text-sm sm:text-base"
            >
              Let&apos;s Collaborate
            </button>
          </div>

          <div className="mt-12 sm:mt-16 flex justify-center gap-6 sm:gap-8 text-white/90 px-4">
            <div className="text-center">
              <div className="text-3xl sm:text-4xl font-serif font-bold mb-1 sm:mb-2">150+</div>
              <div className="text-xs sm:text-sm uppercase tracking-wider">Projects</div>
            </div>
            <div className="w-px bg-white/30"></div>
            <div className="text-center">
              <div className="text-3xl sm:text-4xl font-serif font-bold mb-1 sm:mb-2">80+</div>
              <div className="text-xs sm:text-sm uppercase tracking-wider">Brands</div>
            </div>
            <div className="w-px bg-white/30"></div>
            <div className="text-center">
              <div className="text-3xl sm:text-4xl font-serif font-bold mb-1 sm:mb-2">5+</div>
              <div className="text-xs sm:text-sm uppercase tracking-wider">Years</div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-2xl sm:text-3xl"></i>
      </div>
    </section>
  );
}
